import React, { useEffect, useState } from "react";
import HeaderComponent from "./headerComponent";
import FooterComponent from "./footerComponent";
import { HiOutlineLightBulb } from "react-icons/hi2";
import { RiAlertFill } from "react-icons/ri";
import surveyQuestions from "../utils/SurveyQuestions.json";
import optionArray from "../utils/OptionArray.json";
import CheckBox from "../FormElements/CheckBox";
import RadioBox from "../FormElements/RadioBox";
import RangeSelectBox from "../FormElements/RangeSelectBox";
import DiscreteSelectBox from "../FormElements/DiscreteSelectBox";
import ReviewList from "../FormElements/ReviewList";
const API_SAVE_SURVEYDATA = process.env.REACT_APP_API_URL + '?action=caspResponse';

const Survey = () => {
  let url = window.location.href;
  const ssid = url.split("/").pop();
  const uuid = url.split('/').slice(-2)[0];
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const isLastQuestion = currentQuestionIndex === surveyQuestions.length - 1;
  const [studentuuid] = useState(uuid);
  const [studentssid] = useState(ssid);

  useEffect(() => {
    // Initialize selected answers for each question
    const initialSelectedAnswers = {};
    surveyQuestions.forEach((question) => {
      initialSelectedAnswers[question.questionkey] = []; // Initialize as empty
    });
    initialSelectedAnswers["surveystudentuuid"] = studentuuid
    setSelectedAnswers(initialSelectedAnswers);
  }, []);

  useEffect(() => {
    setSelectAllChecked(false);
  }, [currentQuestionIndex]);

  const handlePreviousQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  const handleOptionChange = (questionKey, checkedArray) => {
    setSelectedAnswers((prevSelectedAnswers) => ({
      ...prevSelectedAnswers,
      [questionKey]: checkedArray,
    }));
  };

  const currentQuestion = surveyQuestions[currentQuestionIndex];
  const questionKey = currentQuestion.questionkey;
  const selectedAnswersForCurrentQuestion = selectedAnswers[questionKey];
  let selectedAnswersLength = selectedAnswersForCurrentQuestion ? selectedAnswersForCurrentQuestion.length : 0;
  const optionData = optionArray.data.masterdata[questionKey];
  const options = optionData.OPTIONS;
  const type = optionData.TYPE;

  const handleNextQuestion = () => {

    // if satscore is 1 then check sub options
    if (questionKey === 'satscore' && questionKey === 'satscore' && selectedAnswers['satscore'] !== null && selectedAnswers['satscore'][0] === 1) {
      if (selectedAnswers["satrwscore"] === undefined || selectedAnswers["satrwscore"].length === 0) {
        return false
      }
      if (selectedAnswers["satmathscore"] === undefined || selectedAnswers["satmathscore"].length === 0) {
        return false
      }
      if (selectedAnswers["singlesittingsatscore"] === undefined ||selectedAnswers["singlesittingsatscore"].length === 0) {
        return false
      }
    }

    // if actscore is 1 then check sub options
    if (questionKey === 'actscore' && selectedAnswers['actscore'] !== null && selectedAnswers['actscore'][0] === 1) {
      if (selectedAnswers["actcompositescore"] === undefined ||  selectedAnswers["actcompositescore"].length === 0) {
        return false
      }
      if (selectedAnswers["actenglishscore"] === undefined || selectedAnswers["actenglishscore"].length === 0) {
        return false
      }
      if (selectedAnswers["actreadingscore"] === undefined || selectedAnswers["actreadingscore"].length === 0) {
        return false
      }
      if (selectedAnswers["actsciencescore"] === undefined || selectedAnswers["actsciencescore"].length === 0) {
        return false
      }
      if (selectedAnswers["actmathscore"] === undefined || selectedAnswers["actmathscore"].length === 0) {
        return false
      }
    }

    // if apibscore is 1 then check sub options
    if (questionKey === 'apibscore' && selectedAnswers['satscore'] !== null && selectedAnswers['apibscore'][0] === 1) {
      if (selectedAnswers["numberofapibsubmit"] === undefined || selectedAnswers["numberofapibsubmit"].length === 0) {
        return false
      }
      if (selectedAnswers["numberofapibscores"] === undefined || selectedAnswers["numberofapibscores"].length == 0) {
        return false
      }
      if (selectedAnswers["numberof4ap6ib"] === undefined || selectedAnswers["numberof4ap6ib"].length === 0) {
        return false
      }
    }

     // check research is yes or not
     if (questionKey === 'research' && selectedAnswers['research'] !== null && selectedAnswers['research'][0] === 1) {
      if(selectedAnswers["researchsub"] === undefined || selectedAnswers["researchsub"] === null || selectedAnswers["researchsub"].length === 0) {
        return false
      }
     }

     // check writtingskills and writtingability 
     if (questionKey === 'writtingskills' && selectedAnswers['writtingskills'] !== null) {
      if(selectedAnswers["writtingability"] === undefined || selectedAnswers["writtingability"].length === 0) {
        return false
      }
     }

    if (currentQuestionIndex < surveyQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };
  const handleSubmit = () => {
    fetch(API_SAVE_SURVEYDATA, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'ssid': studentssid
      },
      body: JSON.stringify(selectedAnswers)
    })
      .then(response => response.json())
      .then(response => {
        if(response.statuscode === 200) {
          window.location.href = '../../survey-success/' + studentuuid + '/' + studentssid;
        } else {
          alert(response.message);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const getQuestionNumberBackgroundColor = (index) => {
    if (index === currentQuestionIndex) {
      return "#2e9026";
    } else if (index < currentQuestionIndex) {
      return "rgba(46, 144, 38, 0.4)";
    }
    return "#e7e7e7";
  };

  const toggleDescriptionVisibility = () => {
    setShowFullDescription(!showFullDescription);
  };

  const handleQuestionNumberClick = (index) => {
    const questionKey = surveyQuestions[index].questionkey;
    const selectedAnswersForSelectedQuestion = selectedAnswers[questionKey];
    const selectedAnswersLengthForSelectedQuestion =
      selectedAnswersForSelectedQuestion
        ? selectedAnswersForSelectedQuestion.length
        : 0;
    if (selectedAnswersLengthForSelectedQuestion > 0) {
      setCurrentQuestionIndex(index);
    }
  };

  return (
    <div className="page-wrapper bg-blue font-robo wrapper-container">
      <div>
        <div className="logo-wrapper survey-padding-wrapper">
          <HeaderComponent />
          <div className="card card-wrapper">
            <div className="survey-card-body">
              <button className="tips-button">
                <HiOutlineLightBulb className="tips-icon" />
                <p className="tips-text">Part-1 Personal Preference Survey</p>
              </button>
              <h2 className="survey-main-head">College Preferences</h2>
              <div className="survey-content-div">
                <div className="survey-sub-head-div">
                  <h5 className="survey-sub-head">Questions</h5>
                  <h5 className="survey-mobile-question-number">
                    {" "}
                    -{" "}
                    {`${(currentQuestionIndex + 1)
                      .toString()
                      .padStart(2, "0")}`}{" "}
                    / {surveyQuestions.length.toString().padStart(2, "0")}
                  </h5>
                </div>
                <div className="survey-question-boxes">
                  <ul>
                    {surveyQuestions.map((_, index) => (
                      <li
                        className="question-boxes"
                        key={index}
                        style={{
                          backgroundColor:
                            getQuestionNumberBackgroundColor(index),
                        }}
                      >
                        <span
                          className="question-number"
                          onClick={() => handleQuestionNumberClick(index)}
                        >
                          {(index + 1).toString().padStart(2, "0")}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
                {surveyQuestions[currentQuestionIndex].notes.length > 0 ? (
                  <div className="attention-container">
                    <div className="attention-box">
                      <div className="attention-head">
                        <RiAlertFill className="attention-icon" />
                        <h5>Attention!</h5>
                      </div>
                      <p className="attention-text">
                        {showFullDescription
                          ? parseHTML(surveyQuestions[currentQuestionIndex].notes)
                          : surveyQuestions[currentQuestionIndex].notes.length >
                            160
                            ? parseHTML(surveyQuestions[currentQuestionIndex].notes.slice(
                              0,
                              160
                            ) + "...")
                            : parseHTML(surveyQuestions[currentQuestionIndex].notes)}
                      </p>
                      <div className="attention-button-container">
                        <button
                          className="attention-button"
                          onClick={toggleDescriptionVisibility}
                        >
                          {showFullDescription
                            ? "Hide Description"
                            : "View Description"}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (null)}
                {/* check whether the question key is review */}
                {/* loop the question and answers */}
                {surveyQuestions[currentQuestionIndex].questionkey === 'review' ? (
                  <div className="row">
                    <ReviewList selectedAnswers={selectedAnswers} surveyQuestions={surveyQuestions} optionArray={optionArray} />
                  </div>
                ) : (
                  <div className="survey-questions-div survey-questions-div-review">
                    <p className="survey-questions-tag">Q.</p>
                    <p className="survey-questions">
                      {currentQuestion.question}
                    </p>
                  </div>
                )}
                <div className="survey-answer-div">
                  {surveyQuestions[currentQuestionIndex].questionkey !== 'review' ? (
                    <p className="survey-answer-sub-text">Here are the options you can choose from,</p>
                  ) : (null)}
                  {type === "checkbox" ? (
                    <CheckBox
                      options={options}
                      selected={selectedAnswers}
                      selectAllChecked={selectAllChecked}
                      onChange={handleOptionChange}
                      questionKey={questionKey}
                    />
                  ) : (null)}
                  {type === "radio" ? (
                    <RadioBox
                      options={options}
                      name={questionKey}
                      selected={selectedAnswers}
                      onChange={handleOptionChange}
                      questionKey={questionKey}
                    />
                  ) : (null)}
                  {type === "range" ? (
                    <RangeSelectBox
                      options={options}
                      name={questionKey}
                      selected={selectedAnswers}
                      onChange={handleOptionChange}
                      questionKey={questionKey}
                    />
                  ) : (null)}
                  {type === "discrete" ? (
                    <DiscreteSelectBox
                      options={options}
                      name={questionKey}
                      selected={selectedAnswers}
                      onChange={handleOptionChange}
                      questionKey={questionKey}
                    />
                  ) : (null)}
                </div>
                {/* If the question key is satscore, then display the sub questions and options */}
                {surveyQuestions[currentQuestionIndex].questionkey === 'satscore' && selectedAnswers["satscore"] !== null ? (
                  <>
                    {selectedAnswers["satscore"][0] === 1 ? (
                      <div className="survey-answer-div">
                        {surveyQuestions[currentQuestionIndex].sub.map((inner, idx) => (
                          <>
                            <div className="survey-questions-div survey-questions-div-review" key={inner.question}>
                              <p className="survey-questions-tag">Q.</p>
                              <p className="survey-questions">
                                {inner.question}
                              </p>
                            </div>
                            <div className="survey-answer-div">
                              {optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].TYPE === "range" ? (
                                <RangeSelectBox
                                  options={optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].OPTIONS}
                                  name={inner.questionkey}
                                  selected={selectedAnswers}
                                  onChange={handleOptionChange}
                                  questionKey={inner.questionkey}
                                />
                              ) : (null)}
                              {optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].TYPE === "discrete" ? (
                                <DiscreteSelectBox
                                  options={optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].OPTIONS}
                                  name={inner.questionkey}
                                  selected={selectedAnswers}
                                  onChange={handleOptionChange}
                                  questionKey={inner.questionkey}
                                />
                              ) : (null)}
                            </div>
                          </>
                        ))}
                      </div>
                    ) : (null)}
                  </>
                ) : (null)}
                {/* If the question key is actscore, then display the sub questions and options */}
                {surveyQuestions[currentQuestionIndex].questionkey === 'actscore' && selectedAnswers["actscore"] !== null ? (
                  <>
                    {selectedAnswers["actscore"][0] === 1 ? (
                      <div className="survey-answer-div">
                        {surveyQuestions[currentQuestionIndex].sub.map((inner, idx) => (
                          <>
                            <div className="survey-questions-div survey-questions-div-review" key={inner.question}>
                              <p className="survey-questions-tag">Q.</p>
                              <p className="survey-questions">
                                {inner.question}
                              </p>
                            </div>
                            <div className="survey-answer-div">
                              {optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].TYPE === "range" ? (
                                <RangeSelectBox
                                  options={optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].OPTIONS}
                                  name={inner.questionkey}
                                  selected={selectedAnswers}
                                  onChange={handleOptionChange}
                                  questionKey={inner.questionkey}
                                />
                              ) : (null)}
                              {optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].TYPE === "discrete" ? (
                                <DiscreteSelectBox
                                  options={optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].OPTIONS}
                                  name={inner.questionkey}
                                  selected={selectedAnswers}
                                  onChange={handleOptionChange}
                                  questionKey={inner.questionkey}
                                />
                              ) : (null)}
                            </div>
                          </>
                        ))}
                      </div>
                    ) : (null)}
                  </>
                ) : (null)}
                {/* If the question key is apib, then display the sub questions and options */}
                {surveyQuestions[currentQuestionIndex].questionkey === 'apibscore' && selectedAnswers["apibscore"] !== null ? (
                  <>
                    {selectedAnswers["apibscore"][0] === 1 ? (
                      <div className="survey-answer-div">
                        {surveyQuestions[currentQuestionIndex].sub.map((inner, idx) => (
                          <>
                            <div className="survey-questions-div survey-questions-div-review" key={inner.question}>
                              <p className="survey-questions-tag">Q.</p>
                              <p className="survey-questions">
                                {inner.question}
                              </p>
                            </div>
                            <div className="survey-answer-div">
                              {optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].TYPE === "range" ? (
                                <RangeSelectBox
                                  options={optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].OPTIONS}
                                  name={inner.questionkey}
                                  selected={selectedAnswers}
                                  onChange={handleOptionChange}
                                  questionKey={inner.questionkey}
                                />
                              ) : (null)}
                              {optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].TYPE === "discrete" ? (
                                <DiscreteSelectBox
                                  options={optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].OPTIONS}
                                  name={inner.questionkey}
                                  selected={selectedAnswers}
                                  onChange={handleOptionChange}
                                  questionKey={inner.questionkey}
                                />
                              ) : (null)}
                            </div>
                          </>
                        ))}
                      </div>
                    ) : (null)}
                  </>
                ) : (null)}
                {/* If the question key is writtingskills, then display the sub questions and options */}
                {surveyQuestions[currentQuestionIndex].questionkey === 'writtingskills' ? (
                  <>
                    <div className="survey-answer-div">
                      {surveyQuestions[currentQuestionIndex].sub.map((inner, idx) => (
                        <>
                          <div className="survey-questions-div survey-questions-div-review" key={inner.question}>
                            <p className="survey-questions-tag">Q.</p>
                            <p className="survey-questions">
                              {inner.question}
                            </p>
                          </div>
                          <div className="survey-answer-div">
                            {optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].TYPE === "range" ? (
                              <RangeSelectBox
                                options={optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].OPTIONS}
                                name={inner.questionkey}
                                selected={selectedAnswers}
                                onChange={handleOptionChange}
                                questionKey={inner.questionkey}
                              />
                            ) : (null)}
                            {optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].TYPE === "discrete" ? (
                              <DiscreteSelectBox
                                options={optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].OPTIONS}
                                name={inner.questionkey}
                                selected={selectedAnswers}
                                onChange={handleOptionChange}
                                questionKey={inner.questionkey}
                              />
                            ) : (null)}
                          </div>
                        </>
                      ))}
                    </div>
                  </>
                ) : (null)}
                {/* If the question key is research, then display the sub questions and options */}
                {surveyQuestions[currentQuestionIndex].questionkey === 'research' && selectedAnswers["research"] !== null ? (
                  <>
                    {selectedAnswers["research"][0] === 1 ? (
                      <div className="survey-answer-div">
                        {surveyQuestions[currentQuestionIndex].sub.map((inner, idx) => (
                          <>
                            <div className="survey-answer-div">
                              {optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].TYPE === "range" ? (
                                <RangeSelectBox
                                  options={optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].OPTIONS}
                                  name={inner.questionkey}
                                  selected={selectedAnswers}
                                  onChange={handleOptionChange}
                                  questionKey={inner.questionkey}
                                />
                              ) : (null)}
                              {optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].TYPE === "discrete" ? (
                                <DiscreteSelectBox
                                  options={optionArray.data.masterdata[questionKey].suboptions[inner.questionkey].OPTIONS}
                                  name={inner.questionkey}
                                  selected={selectedAnswers}
                                  onChange={handleOptionChange}
                                  questionKey={inner.questionkey}
                                />
                              ) : (null)}
                            </div>
                          </>
                        ))}
                      </div>
                    ) : (null)}
                  </>
                ) : (null)}
              </div>
              <div className="survey-button-div">
                <button
                  type="submit"
                  value="Submit"
                  onClick={handlePreviousQuestion}
                  className={`${currentQuestionIndex === 0 ? "transparent-button" : "previous-button"}`}
                >
                  Previous
                </button>
                {isLastQuestion ? (
                  <button
                    type="submit"
                    value="Submit"
                    onClick={handleSubmit}
                    className="next-button"
                  >
                    Submit
                  </button>
                ) : (
                  <button
                    type="submit"
                    value="Submit"
                    onClick={handleNextQuestion}
                    disabled={!selectedAnswersLength}
                    className="next-button"
                  >
                    Next
                  </button>
                )}
              </div>
            </div>
          </div>
          <FooterComponent />
        </div>
      </div>
    </div>
  );
};
const parseHTML = (html) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: html }} />
  );
};

export default Survey;
